import * as config from "./config";

export function generateEmptyUserSearchCriteria() {
    return {
        RoleId: null,
        DistrictId: null,
        DivisionId: null,
        AffiliationId: null,
        EmployeeType: null,
        NameEmailContains: "",
        Page: 1,
        RecordsPerPage: config.defaultRecordsPerPage,
        OrderByColumn: "Last Name",
        OrderDescending: false,
        searchPerformed: false
    };
}

export function generateEmployeeTypeOptions() {
    return [
        { value: "1", text: "DOE employee" },
        { value: "2", text: "DOE contractor" },
        { value: "3", text: "School district employee" },
    ];
}